import { useEffect } from "react";
import { Userpilot } from "userpilot";

Userpilot.initialize(process.env.REACT_APP_USERPILOT_KEY);

const useUserPilot = () => {
  useEffect(() => {
    Userpilot.clean();
  }, []);

  return Userpilot;
};

export default useUserPilot;
